/* eslint-disable @typescript-eslint/naming-convention */
import {Injectable} from '@angular/core';
import {CommandMap, CommandsDescriptor} from '@app/models/commands/commands-descriptor';
import {MessageRecord} from '@app/services/data.service';
import {AssignmentService} from '@app/modules/whiteboard/services/assignment.service';
import {Store} from '@ngxs/store';
import {ExecBuffer} from '@app/models/exec-buffer';

export enum AssignmentEvents {
  REFRESH = 'REFRESH',
  REFRESH_USERS_ASSIGNMENT = 'REFRESH_USERS_ASSIGNMENT'
}

export enum AssignmentStates {
  LOAD = 'LOAD',
  UNLOAD = 'UNLOAD',
  LAST_ASSIGNMENT_REPORT = 'LAST_ASSIGNMENT_REPORT',
  ASSIGNMENT_SWITCH_FOR_ALL = 'ASSIGNMENT_SWITCH_FOR_ALL',
  DISALLOW_ASSIGNMENT_SWITCH_FOR_ALL = 'DISALLOW_ASSIGNMENT_SWITCH_FOR_ALL',
  ALLOW_SWITCHER_FOR = 'ALLOW_SWITCHER_FOR',
  DISALLOW_SWITCHER_FOR = 'DISALLOW_SWITCHER_FOR',
  VIEW_PORT = 'VIEW_PORT'
}


@Injectable({
  providedIn: 'root'
})
export class AssignmentCommands extends CommandsDescriptor<AssignmentEvents, AssignmentStates> {

  static category = 'ASSIGNMENT';

  constructor(private assignmentService: AssignmentService, store: Store) {

    const MAP: CommandMap<AssignmentEvents, AssignmentStates> = {
      EVENT: {
        REFRESH: () => this.assignmentService.onRefresh(),
        REFRESH_USERS_ASSIGNMENT: () => this.assignmentService.onUsersRefresh()
      },
      STATE: {
        LOAD: (record: MessageRecord) => this.assignmentService.onLoad(record),
        UNLOAD: (record: MessageRecord) => this.assignmentService.onUnload(record),
        LAST_ASSIGNMENT_REPORT: (record: MessageRecord) => this.assignmentService.onLastAssignmentReport(record),
        ASSIGNMENT_SWITCH_FOR_ALL: (record: MessageRecord) => this.assignmentService.onAllowSwitchForAll(record),
        DISALLOW_ASSIGNMENT_SWITCH_FOR_ALL: (record: MessageRecord) => this.assignmentService.onDisallowSwitchForAll(record),
        ALLOW_SWITCHER_FOR: (record: MessageRecord) => this.assignmentService.onAllowSwitcherAccessFor(record),
        DISALLOW_SWITCHER_FOR: (record: MessageRecord) => this.assignmentService.onDisallowSwitcherAccessFor(record),
        VIEW_PORT: (record: MessageRecord) => this.assignmentService.onViewPort(record)
      }
    };
    super(MAP, new ExecBuffer(true), store);
    this.assignmentService.handleRecordStack = this.handleRecordStack.bind(this);
  }
}
